// Settings → Users & Access search. Pure client-side filtering over the rows
// that screen has already loaded for the viewer (claimed logins, pending
// invites, roster-only Contacts), so it can never reach a record outside the
// viewer's existing scope. It only narrows what is displayed; order is kept.

export interface UserSearchFields {
  name: string;
  email: string;
  district: string;
  positions: string[];
}

const norm = (v: string) => v.toLowerCase().replace(/\s+/g, ' ').trim();

/** Every whitespace-separated word must appear somewhere in the row's name,
 *  email, district or any position (case-insensitive, partial). Words may
 *  come from different fields, so "pat sycamore" finds Pat in Sycamore and
 *  "smith pat" finds "Pat Smith". */
export function matchesUserSearch(fields: UserSearchFields, query: string): boolean {
  const tokens = norm(query).split(' ').filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = norm([fields.name, fields.email, fields.district, ...fields.positions].join(' '));
  return tokens.every((t) => haystack.includes(t));
}

export function filterUserRows<T>(rows: T[], query: string, fieldsOf: (row: T) => UserSearchFields): T[] {
  if (!norm(query)) return rows;
  return rows.filter((row) => matchesUserSearch(fieldsOf(row), query));
}

export function matchCountLabel(n: number): string {
  return `${n} matching ${n === 1 ? 'user' : 'users'}`;
}
